/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { TextField } from '@mui/material';
import { SSN_REGEX } from 'common-constants/validation';
import VisibilityToggle from 'common-mui/components/VisibilityToggle';
import ValidatedTextField from 'common-mui/components//ValidatedTextField';
import { useFormContext } from 'react-hook-form';
import Mask from './Mask';

export const transform = (v) => v.replace(/-/g, '');

const InputTIN = ({ name = 'ssn', label = 'SSN/ITIN' }) => {
  const { control } = useFormContext();
  return (
    <ValidatedTextField
      name={name}
      control={control}
      rules={{
        required: 'This field is required.',
        pattern: {
          value: SSN_REGEX,
          message: `Please enter a valid 9-digit ${label}.`,
        },
      }}
    >
      <VisibilityToggle>
        {({ isVisible, endAdornment, ...props }) => (
          <TextField
            {...props}
            autoComplete="off"
            fullWidth
            label={label}
            inputProps={{
              sx: !isVisible && { fontFamily: 'ssnFont', letterSpacing: '3px' },
              'data-dd-privacy': 'mask-user-input',
            }}
            InputProps={{ // eslint-disable-line react/jsx-no-duplicate-props
              inputComponent: Mask,
              endAdornment,
            }}
          />
        )}
      </VisibilityToggle>
    </ValidatedTextField>
  );
};

export default InputTIN;
